import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import rules from '@/app/shared/domain/data/rules';
import {inject, onMounted, reactive, ref, watch} from 'vue';
import InputMoney from '@/app/shared/components/inputs/InputMoney.vue';
import useRefundCategoryState from '@/app/refund/infrastructure/persistence/RefundCategoryState';
import useNotification from '@/app/shared/infrastructure/persistence/notification-repository';
import CollaboratorRepository from '../infrastructure/persistence/CollaboratorRepository';


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestRefund',
  props: ['collaborator'],
  setup(__props) {

const props = __props;

const requestRefundForm = ref(null);

const categoriesState = useRefundCategoryState();
const notifications = useNotification();
const collaboratorRepository = inject('collaboratorRepository') as CollaboratorRepository;

const refundCategoriesOptions = ref<any[]>([]);

onMounted(async () => {
    refundCategoriesOptions.value = await categoriesState.getAllSimple();
});

const options = reactive({
    request_refund: null,
    request_refund_until: '',
    refund_categories: []
});

watch(props, (newProps) => {
    const requestRefundUntil = newProps.collaborator.request_refund_until;
    options.request_refund = newProps.collaborator.request_refund;
    options.request_refund_until = requestRefundUntil ? String(requestRefundUntil) : '';
    options.refund_categories = newProps.collaborator.refund_categories;
});

async function updatePermission() {
    if (
        options.request_refund
        && options.request_refund_until === null
    ) {
        notifications.insert({
            type: 'warning',
            message: 'Insira o valor limite para reembolso automático',
            id: Date.now().toString(),
        });
        return;
    }

    if (
        options.request_refund
        && options.refund_categories.length === 0
    ) {
        notifications.insert({
            type: 'warning',
            message: 'Selecione as categorias permitidas',
            id: Date.now().toString(),
        });
        return;
    }

    try {
        await collaboratorRepository.updatePermission(props.collaborator.id, options);

        notifications.insert({
            type: 'success',
            message: 'Permissão alterada com sucesso',
            id: Date.now().toString(),
        });
    } catch (error) {
        notifications.insert({
            type: 'error',
            message: 'Não foi possivel alterar a permissão.',
            id: Date.now().toString(),
        });
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    "lazy-validation": "",
    ref_key: "requestRefundForm",
    ref: requestRefundForm
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                modelValue: options.request_refund,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((options.request_refund) = $event)),
                inset: "",
                color: "primary",
                label: "Solicita reembolso"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                onClick: updatePermission
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Atualizar")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (options.request_refund)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(InputMoney, {
                    rules: [_unref(rules).required],
                    label: "Limite de aprovação automática",
                    modelValue: options.request_refund_until,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options.request_refund_until) = $event)),
                    modelModifiers: { lazy: true }
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (options.request_refund)
            ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }))
            : _createCommentVNode("", true),
          (options.request_refund)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "12",
                sm: "6",
                "align-self": "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    rules: [_unref(rules).required],
                    modelValue: options.refund_categories,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((options.refund_categories) = $event)),
                    items: refundCategoriesOptions.value,
                    "item-value": "id",
                    "item-title": "name",
                    chips: "",
                    label: "Categorias de reembolso",
                    multiple: ""
                  }, null, 8, ["rules", "modelValue", "items"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})